import React, { useState, useEffect, useRef } from 'react'
import '../css/components/OrderHistory.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Logo from '../assets/logo.png';
import Loading from '../general/Loading';
import Default from '../assets/default.jpg';


const OrderHistory = ({ userData }) => {
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showInvoice, setShowInvoice] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState();
  const [selectedOrderPay, setSelectedOrderPay] = useState();
  const [loading, setLoading] = useState(false);
    const today = new Date();
  const priorDate = new Date();
  priorDate.setDate(today.getDate() - 3);

  const formatInputDate = (date) => {
    // YYYY-MM-DD format for input type="date"
    return date.toISOString().split('T')[0];
  };

   const [fromDate, setFromDate] = useState(formatInputDate(priorDate));
    const [toDate, setToDate] = useState(formatInputDate(today));
  
    
    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);


  const handleFromIconClick = () => {
    fromDateRef.current?.showPicker();
  };
  
  const handleToIconClick = () => {
    toDateRef.current?.showPicker();
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://api.kcmstore.in/dist/get-order/${userData.id}`);
        setLoading(false);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          setOrders(sortedProducts);
        } else {
          setLoading(false);
          console.error('Failed to fetch products');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching products:', error);
      }
    };

    fetchOrders();
  }, [userData.id]);


  const fetchPaymentDetails = async (orderId) => {
    try {
      const response = await fetch(`https://api.kcmstore.in/dist/get-payment/${orderId}`);
      if (response.ok) {
        const data = await response.json();
        setSelectedOrderPay(data);
      } else {
        console.error('Failed to fetch payment details');
        setSelectedOrderPay();
      }
    } catch (error) {
      setSelectedOrderPay();
      console.error('Error fetching payment details:', error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };
  
const filteredOrders = orders.filter(order => {
  const orderDate = new Date(order.order_date);
  orderDate.setHours(0, 0, 0, 0); // normalize time

  const from = fromDate ? new Date(fromDate) : null;
  const to = toDate ? new Date(toDate) : null;
  if (from) from.setHours(0, 0, 0, 0);
  if (to) to.setHours(0, 0, 0, 0);

  const orderItems = JSON.parse(order.order_items);

  const isInDateRange = (!from || orderDate >= from) && (!to || orderDate <= to);

  const isProductNameMatch = orderItems.some(item =>
    item.product_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Show only if order is in date range AND matches search query (if search query is present)
  return isInDateRange && (searchQuery ? isProductNameMatch : true);
});
  const showInvoiceDialog = (order) => {
    setSelectedOrder(order);
    setShowInvoice(true);
    console.log(order.id);
    fetchPaymentDetails(order.id);
  }

  const handlePrint = () => {
    window.print();
  }

  return (
    <>
      <section className='px-3 py-3'>
        <div className='profile-area-inner px-lg-5 py-lg-5 px-3 py-3 animate__animated animate__fadeInUp'>
          <p className='profile-heading'>Order History</p>
          {/* <hr className='profile-hr my-0' /> */}

          <div className="text-start mb-4">
            <input
              type="text"
              className="profile-input rounded border-0 bg-light"
              placeholder="🎯 Search order here..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="d-flex justify-content-between my-3">
  {/* From Date */}
  <div className="position-relative d-flex align-items-center">
    <label className="form-label fw-semibold me-2 my-2">From Date</label>

    {/* Hidden but positioned input */}
    <input
      type="date"
      ref={fromDateRef}
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
      className="position-absolute"
      style={{
        opacity: 0,
        width: '38px', // Same size as button
        height: '38px',
        cursor: 'pointer',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
      }}
    />

    <button className="btn border px-3 py-2 position-relative" onClick={handleFromIconClick}>
      <i className="fa-solid fa-calendar-days"></i>
    </button>
  </div>

  {/* To Date */}
  <div className="position-relative d-flex align-items-center">
    <label className="form-label fw-semibold me-2 my-2">To Date</label>

    <input
      type="date"
      ref={toDateRef}
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      className="position-absolute"
      style={{
        opacity: 0,
        width: '38px',
        height: '38px',
        cursor: 'pointer',
        left: 0,
        top: '50%',
        transform: 'translate(-200%, -50%)',
      }}
    />

    <button className="btn border px-3 py-2 position-relative" onClick={handleToIconClick}>
      <i className="fa-solid fa-calendar-days"></i>
    </button>
  </div>
</div>

{(fromDate && toDate) && (
  <p className="fw-semibold text-muted">
    Showing orders from {formatDate(fromDate || '...')} to {formatDate(toDate || '...')}
  </p>
)}
          <hr />

          {filteredOrders.length > 0 ? (
            filteredOrders.map((order) => {
              const orderItems = JSON.parse(order.order_items);
              return (
                <div className='my-3' key={order.id}>
                  <div className='order-area'>
                    <p className='fw-semibold'>Order placed on {formatDate(order.order_date)}</p>
                    <Swiper spaceBetween={20} slidesPerView={6} modules={[Navigation]} loop={true}
                      navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                      breakpoints={{
                        0: {
                          slidesPerView: 2,
                        },
                        768: {
                          slidesPerView: 4,
                        },
                        992: {
                          slidesPerView: 6,
                        }
                      }}>
                      {orderItems.length > 0 ? (
                        orderItems.map((item, index) => (
                          <>
                            <SwiperSlide key={index} className='my-2'>
                              <img
                                src={item.image
                                  ? `https://api.kcmstore.in/uploads/${item.image.split(',')[0]}`
                                : Default}
                                className='img-fluid col-md-10 col-12'
                                alt='Order'
                              />
                              {/* <div className='ms-3 align-content-center'> */}
                              <p className='my-0 para-text'>{item.product_name}</p>
                              {/* <span className='text-muted para-text'>{item.quantity} Item</span> */}
                              {/* </div> */}
                            </SwiperSlide>
                          </>
                        ))
                      ) : (
                        <p>No items in this order</p>
                      )}
                    </Swiper>
                    <p className='para-text fw-semibold my-3'>
                      {/* Order Total ₹ {order.total_amount}<br /> */}
                      Your Order has been {order.order_status == 'Placed' ? 'Placed. Please Wait for its Confirmation.' : order.order_status}{order.order_status != 'Delivered' && (order.delivery_time == null ? '' : ` & will reach you in ${order.delivery_time}.`)}
                    </p>

                    <button className='add-btn rounded' onClick={() => showInvoiceDialog(order)}>Download Invoice <i class="fa-solid fa-file-lines"></i></button>
                    <hr />
                  </div>
                </div>
              );
            })
          ) : (
            <p>No Orders Placed yet</p>
          )}


        </div>
      </section>


      {showInvoice && selectedOrder && (
        <>
          <section className='invoice-dialog' onClick={() => setShowInvoice(false)}>
            <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>

              <p className='profile-subheading text-center'>Order Invoice</p>
              <img src={Logo} className='invoice-watermark' alt='WaterMark' />

              <div className='invoice-area'>


                <p className='fw-semibold my-0'>Sold By: KCM Pharmacy</p>
                <p className='para-text fst-italic my-0'><span className='fw-semibold'>Billing Address:</span> Berhampur, Ganjam, Odisha, 760004</p>
                <p className='para-text fst-italic my-0'><span className='fw-semibold'>GSTIN: </span>21AAICK6518NIZA<br />
                </p>


                <div className='text-end'>
                  <span className='invoice-num fw-semibold'>Invoice Number {selectedOrderPay?.id || 'NA'}</span></div>

                <hr />

                <div className='d-flex pt-2'>
                  <div>
                    <p className='fw-semibold my-0'>Order Id: {selectedOrder.id}</p>
                    <p><span className='fw-semibold'>Order Date: </span>{formatDateTime(selectedOrder.order_date)}</p></div>

                  <p className='ms-4'><span className='fw-semibold'>Delivery Address</span><br />
                    {selectedOrder.user_address} {selectedOrder.user_city} {selectedOrder.user_state}</p>

                </div>
                {/* flex ends */}

                <hr />


                <div className='table-responsive'>
                  <table className='w-100'>
                    <tr>
                      <th className='fw-semibold px-2'>Product</th>
                      <th className='fw-semibold px-2'>Qty</th>
                      <th className='fw-semibold px-2'>MRP</th>
                      <th className='fw-semibold px-2'>Discount</th>
                      <th className='fw-semibold px-2'>Tax</th>
                      <th className='fw-semibold px-2'>Free Qty</th>
                      <th className='fw-semibold px-2'>Sale Price</th>
                      <th className='fw-semibold px-2'>Total</th>
                    </tr>

{typeof selectedOrder.order_items === 'string' ? (
  (() => {
    try {
      const parsedItems = JSON.parse(selectedOrder.order_items);
      if (Array.isArray(parsedItems)) {
        const totalItems = parsedItems.reduce(
          (acc, item) => acc + (parseInt(item.quantity) || 0),
          0
        );

        return (
          <>
            {parsedItems.map((item, index) => (
              <tr key={index}>
                <td className='px-2 py-2'>{item.product_name}</td>
                <td className='px-2 py-2'>{item.quantity}</td>
                <td className='px-2 py-2'>₹{item.product_org}</td>
                <td className='px-2 py-2'>
                  {item.product_discount_type === 'amount' ? '₹' : ''}
                  {item.product_discount_amount || 'NA'}
                  {item.product_discount_type === 'percent' ? '%' : ''}
                </td>
                <td className='px-2 py-2'>
                  {item.product_tax && item.product_tax.toLowerCase() !== 'none'
                    ? (() => {
                        const match = item.product_tax.match(/([\d.]+)/);
                        const taxValue = match ? parseFloat(match[0]) : null;

                        if (!isNaN(taxValue) && taxValue > 0) {
                          if (taxValue === 0.25 || taxValue === 0) {
                            return `GST ${taxValue}%`;
                          }
                          const halfTax = (taxValue / 2).toFixed(2);
                          return `CGST ${halfTax}% SGST ${halfTax}%`;
                        }
                        return item.product_tax;
                      })()
                    : 'none'}
                </td>
                <td className='px-2 py-2'>{item.free || 'NA'}</td>
                <td className='px-2 py-2'>₹{item.product_sp}</td>
                <td className='px-2 py-2'>₹{(item.product_sp * item.quantity).toFixed(2)}</td>
              </tr>
            ))}

              <td colSpan="8">
                            <hr />
</td>

            {/* Total items row */}
            <tr>
              <td colSpan="8" className="para-text fw-semibold">
                Total Items: {totalItems}
              </td>
            </tr>
          </>
        );
      }
    } catch (error) {
      return <p>Failed to get items.</p>;
    }
  })()
) : (
  <p>No items available.</p>
)}


                  </table>
                </div>


                {selectedOrder.payment_mode == 'Cash' ?
                  <span className='para-text'>Payment Mode: {selectedOrder.payment_mode}<br />Payment Status: {selectedOrder.payment_status}</span> :
                  <span>Payment Mode: {selectedOrder.payment_mode}<br />Payment Id: {selectedOrder.payment_id}<br />
                    Payment Status: {selectedOrder.payment_status}<br /></span>}


                <p className='para-text fw-semibold text-end'>Grand Total {selectedOrder.total_amount}<br />Amount Paid: {selectedOrderPay?.amount_received || 'NA'} <br />Due Amount: {selectedOrderPay?.due_amount || 'NA'}</p>

                <p className='para-text text-center mt-4'>Thanks for choosing KCM Distributors as your Medicine Supplier.</p>


              </div>
              {/* invoice ends */}


              {/* <div className='invoice-area'>
                <div className='d-flex justify-content-between'>
                  <p>Sold By: KCM Store<br />GSTIN: <br />Invoice No: {selectedOrderPay?.id || 'NA'}<br />Order Status: {selectedOrder.order_status}</p>
                  <p>Order Id: {selectedOrder.id}<br />Order Date: {formatDate(selectedOrder.order_date)}<br />Billing Address: {selectedOrder.user_name}<br />
                    {selectedOrder.user_address} {selectedOrder.user_city} {selectedOrder.user_state}</p>
                </div>
                <hr />

                <div className='table-responsive'>
                  <table className='w-100'>
                    <tr>
                      <th>Product</th>
                      <th>List Price</th>
                      <th>Discount</th>
                      <th>Tax Value</th>
                      <th>Sell Price</th>
                      <th>Qty</th>
                      <th>Total</th>
                    </tr>

                    {typeof selectedOrder.order_items === 'string' ? (
                      (() => {
                        try {
                          const parsedItems = JSON.parse(selectedOrder.order_items);
                          if (Array.isArray(parsedItems)) {
                            return parsedItems.map((item, index) => (
                              <tr key={index}>
                                <td>{item.product_name}</td>
                                <td>₹{item.product_org}</td>
                                <td>{item.product_discount_type == 'amount' ? '₹' : ''}{item.product_discount_amount || 'NA'}{item.product_discount_type == 'percent' ? '%' : ''}</td>
                                <td>{item.product_tax || 'none'}</td>
                                <td>₹{item.product_sp}</td>
                                <td>{item.quantity}</td>
                                <td>₹{item.product_sp * item.quantity}</td>
                              </tr>
                            ));
                          }
                        } catch (error) {
                          return <p>Failed to get items.</p>
                        }
                      })()
                    ) : (
                      <p>No items available.</p>
                    )}

                  </table>
                </div>

                <hr />

                <p>Grand Total ₹{selectedOrder.total_amount}<br />Amount Paid: {selectedOrderPay?.amount_received || 'NA'} <br />Due Amount: {selectedOrderPay?.due_amount || 'NA'}</p>

                <p className='para-text text-center mb-0 mt-4'>Thanks for choosing KCM Distributors as your Medicine Supplier.</p>

              </div> */}
              {/* invoice ends */}
              <button className='login-btn px-3 py-2 mt-4 bg-danger' onClick={() => setShowInvoice(false)}>Close</button>&nbsp;&nbsp;
              <button className='login-btn px-3 py-2 mt-4' onClick={handlePrint}>Download</button>


            </div>
          </section>
        </>
      )}

      {loading && <Loading setLoading={setLoading} />}


    </>
  )
}

export default OrderHistory
